import { invokeFunction, supabase } from "./supabase";
import { isFixtureMode } from "./memberService";
import type { ApplicationDraft, ReviewStatus } from "./types";

export interface DiscordIdentity {
  id: string;
  username: string;
  email: string;
}

async function fixtures() {
  if (!import.meta.env.DEV) throw new Error("Development fixtures are unavailable in production.");
  return import("./applicationFixtures");
}

export async function getDiscordIdentity(): Promise<DiscordIdentity | null> {
  if (isFixtureMode) return (await fixtures()).fixtureDiscordIdentity;
  if (!supabase) return null;
  const { data } = await supabase.auth.getSession();
  const user = data.session?.user;
  if (!user) return null;
  const discord = user.identities?.find((identity) => identity.provider === "discord");
  const id = String(discord?.identity_data?.sub ?? user.user_metadata?.provider_id ?? "");
  if (!id) return null;
  return {
    id,
    username: String(discord?.identity_data?.full_name ?? user.user_metadata?.full_name ?? user.user_metadata?.name ?? "Discord member"),
    email: user.email ?? "",
  };
}

export async function submitApplication(application: ApplicationDraft, idempotencyKey: string, turnstileToken: string) {
  if (!isFixtureMode) {
    return invokeFunction<{ reviewToken: string }>("submit-application", { application, idempotencyKey, turnstileToken });
  }
  return (await fixtures()).submitFixtureApplication();
}

export async function getReviewStatus(token: string): Promise<ReviewStatus> {
  if (!isFixtureMode) return invokeFunction<ReviewStatus>("get-review-status", { token });
  return (await fixtures()).getFixtureReviewStatus(token);
}
